import { useEffect, useState } from 'react';
import LocasearchPlaceholder from '../assets/branding/localsearch-placeholder.jpg';

const useCheckBestImage = (data, MIN_WIDTH = 295, MIN_HEIGHT = 220) => {
  const [bestImage, setBestImage] = useState();
  const placeholder = {
    src: LocasearchPlaceholder,
    placeholder: true,
  };

  const checkImages = images => {
    let hasBestImage;
    return images.reduce((agg, img) => {
      const { width, height, s3_web_path: src } = img || {};
      if (width >= MIN_WIDTH && height >= MIN_HEIGHT && !hasBestImage) {
        hasBestImage = true;
        return {
          src,
        };
      }
      if (hasBestImage) return agg;
      return placeholder;
    }, {});
  };

  useEffect(() => {
    if (data && !!data.length) {
      const images = data || [];
      const image = checkImages(images);
      setBestImage(image);
    } else {
      setBestImage(placeholder);
    }
  }, [data]);

  return { bestImage, checkImages };
};

export default useCheckBestImage;
